import { r as registerInstance, f as forceUpdate, h, H as Host } from './index-dba4409d.js';
import { i as i18nProvider, l as loadTranslations } from './loadTranslations-98801f99.js';

const CreateServiceCaseModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.handleModalClose = () => {
            window.location.reload();
        };
        this.fileUpload = false;
        this.prefillData = null;
        this.modalName = undefined;
        this.locale = "en-US";
        this.env = "prod";
        this.legacyApi = false;
        this.submitted = false;
    }
    handleServiceCaseSuccess() {
        this.modal.triggerClose();
    }
    handleServiceCaseCancel() {
        this.modal.triggerClose();
    }
    connectedCallback() {
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
        this.onLocaleChange();
    }
    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
    }
    onLocaleChange() {
        if (this.locale !== i18nProvider.language) {
            this.loadTranslations();
        }
    }
    handleServiceCaseShowSuccess() {
        this.submitted = true;
    }
    loadTranslations() {
        loadTranslations(this.locale).then((locale) => {
            i18nProvider.changeLanguage(locale);
            this.locale = locale;
        });
    }
    render() {
        const t = (key, options = undefined) => i18nProvider.t(`mf-service-calls:${String(key)}`, options);
        return (h(Host, { key: '7d9d29bc8d845b9c2467ca7f5ec19a8dc5c08050' }, h("ux-modal", { key: '601a8b112f4265fa02d88d5fd178e373a2f8ecda', onUxModalClose: () => this.handleModalClose(), name: this.modalName, ref: (el) => (this.modal = el) }, h("ux-modal-content", { key: '8af04eaea808a21da46d848ed271c2ca38a9f9b4' }, h("mf-create-service-case", { key: 'b77674cda799208a58bde4378520cdb4ee690d84', fileUpload: this.fileUpload, prefillData: this.prefillData, multipleSteps: true, locale: this.locale, env: this.env, legacyApi: this.legacyApi }, h("slot", { key: 'fcc533df72aa6178e27ca7909b10aad500017ca7', name: "connector" }))), this.submitted && (h("ux-modal-footer", { key: '8249e39c3e6b949c20097bdd6f34ae8423518a6f' }, h("ux-button", { key: 'c97726738de7d475930c5f587f673ac07c0df5f9', variant: "primary", onClick: () => {
                this.modal.triggerClose();
            } }, t("button.ok")))))));
    }
    static get watchers() { return {
        "locale": ["onLocaleChange"]
    }; }
};

export { CreateServiceCaseModal as mf_create_service_case_modal };

//# sourceMappingURL=mf-create-service-case-modal.entry.js.map